// extracted by mini-css-extract-plugin
module.exports = {"div":"MemoryMenu_div__3P6Le","b":"MemoryMenu_b__21vX2"};